import { Component, OnInit, ElementRef, ViewChild, Input, Output, EventEmitter, HostBinding } from '@angular/core';
import { TournamentsService } from '~/legacy/ts/tournaments/services/tournaments.service';
import { Observable } from 'rxjs';
import { uiHelper } from '~/helpers/ui.helper';
import { GetOddData } from '~/modules/getOddData';

declare let $;
declare let SetLanguage: any;

@Component({
    selector: 'div.secondRowComponent',
    templateUrl: './match.row.2nd.html',
})
export class MatchRow2nd implements OnInit {
    @Input() fixtureItem: any;
    @Input() indexOfItem: any;

    @Input() typeOfList: string;
    @Input() hidingOfThird;
    @Input() hidingOfFirst;

    @Input() oddValues = [{}, {}, {}];

    @HostBinding('class')
    get hostClasses(): string {
        return [this.typeOfList].join(' ');
    }

    constructor(public tournamentsService: TournamentsService, private _uiHelper: uiHelper, public _GD: GetOddData) {}

    ngOnInit() {}
}
